import React, { useState, useEffect } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  Information as InformationView,
  SettingIMS,
  SettingCMMS,
  Notify,
} from '../views/Information';
import { HomeNavbar } from '../components/Navbars';
import { MainFooter } from '../components/Footers';
import { MainSidebar } from '../components/Sidebar';
import * as actions from '../redux/actions';
import { Loading } from '../components/Loading';
import { NotFound } from '../components/Error';
import accessRight from '../utils/functions/accessRight';
import { Customers } from 'views/Customer';
import { DetailCustomer } from 'views/Customer';
import { EditCustomer } from 'views/Customer';
import { Place } from 'views/Material';
import { EditPlace } from 'views/Material';
import { MaterialType } from 'views/Material';
import { EditMaterilType } from 'views/Material';
import { Employees } from 'views/User';
import { EditEmployee } from 'views/User';
import { DetailUser } from 'views/User';
import { Departments } from 'views/User';
import { EditDepartment } from 'views/User';
import { EditUser } from 'views/User';
import { Users } from 'views/User';

export function Information() {
  const module = 'INFORMATION';
  const prefix = '/information';
  const name = 'การตั้งค่า';
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const me = useSelector((state) => state.me);
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };
  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };

  useEffect(() => {
    dispatch(actions.meGet());
    return () => {};
  }, []);

  if (!me.userData) {
    return <Loading />;
  }
  if (accessRight(me, module)) {
    return (
      <div className="min-h-screen">
        <MainSidebar
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          me={me}
        />
        <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />
        <div className="lg:ml-64  min-h-screen  pt-16 px-8 ">
          <div className="py-4">
            <Switch>
              {/* <Redirect exact from={`${prefix}`} to={`${prefix}`} /> */}
              <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
              <Route exact path={`${prefix}`}>
                <InformationView title={'ข้อมูลระบบ'} subtitle={name} />
              </Route>
              {/*จัดการข้อมูลลูกค้า*/}
              <Route exact path={`${prefix}`}>
                <InformationView title={'ตั้งค่าแดชบอร์ด'} subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/customers`}>
                <Customers title={'รายการลูกค้า'} subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/customer/:id`}>
                <DetailCustomer title={'รายละเอียดลูกค้า'} subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/customer/edit/:id`}>
                <EditCustomer title={'แก้ไขข้อมูลลูกค้า'} subtitle={name} />
              </Route>
              {/*จัดการคลังทอง*/}
              <Route exact path={`${prefix}/place`}>
                <Place title="จัดการคลังทอง" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/place/edit/:id`}>
                <EditPlace title="แก้ไขการคลังทอง" subtitle={name} />
              </Route>
              {/*จัดการพนักงาน*/}
              <Route exact path={`${prefix}/employee`}>
                <Employees title="จัดการพนักงาน" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/employee/edit/:id`}>
                <EditEmployee title="แก้ไขข้อมูลพนักงาน" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/employee/detail/:id`}>
                <DetailUser title="รายละเอียดผู้ใช้งาน " subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/department`}>
                <Departments title="จัดการแผนก" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/department/edit/:id`}>
                <EditDepartment title="แก้ไขข้อมูลแผนก" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/user`}>
                <Users title="จัดการผู้ใช้" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/user/edit/:id`}>
                <EditUser title="แก้ไขข้อมูล" subtitle={name} />
              </Route>
              {accessRight(me, module, 1) && (
                <Switch>
                  <Route exact path={`${prefix}/setting-ims`}>
                    <SettingIMS
                      title={'ตั้งค่าระบบคลังวัสดุ'}
                      subtitle={name}
                    />
                  </Route>
                  <Route exact path={`${prefix}/notify`}>
                    <Notify title={'การแจ้งเตือน'} subtitle={name} />
                  </Route>{' '}
                  <Route exact path={`${prefix}/notify/`}>
                    <Notify title={'การแจ้งเตือน'} subtitle={name} />
                  </Route>
                  <Route path="*">
                    <NotFound />
                  </Route>
                  <Route path="/*">
                    <NotFound />
                  </Route>
                </Switch>
              )}
              <Route path="*">
                <NotFound />
              </Route>
            </Switch>
          </div>
        </div>
        <div className="lg:ml-64">
          <MainFooter />
        </div>
      </div>
    );
  }
  return <></>;
}

export default Information;
